import * as React from "react";
import { ResponsivePopover } from "@/components/ui/responsive-popover";
import { cn } from "@/lib/utils";
import { ResponsiveCommandMultiSelectList } from "./ResponsiveCommandMultiSelectList";
import type { SelectOption } from "./types";

interface ResponsiveCommandMultiSelectDesktopProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  triggerWidth: number | null;
  title: string;
  highZIndex: boolean;
  trigger: React.ReactNode;
  listProps: React.ComponentProps<typeof ResponsiveCommandMultiSelectList>;
}

export function ResponsiveCommandMultiSelectDesktop({
  open,
  onOpenChange,
  triggerWidth,
  title,
  highZIndex,
  trigger,
  listProps,
}: ResponsiveCommandMultiSelectDesktopProps) {
  const [isInDialog, setIsInDialog] = React.useState(false);

  React.useEffect(() => {
    if (open) {
      // Check if we're inside a dialog
      const dialogContent = document.querySelector("[data-slot=\"dialog-content\"]");
      setIsInDialog(!!dialogContent);
    }
  }, [open]);

  return (
    <ResponsivePopover
      open={open}
      onOpenChange={onOpenChange}
      content={
        <div
          className="max-h-[70vh] overflow-y-auto"
          style={
            triggerWidth
              ? {
                  minWidth: `${triggerWidth}px`,
                  width: "fit-content",
                  maxWidth: "600px",
                }
              : {
                  minWidth: "300px",
                  width: "fit-content",
                  maxWidth: "600px",
                }
          }
        >
          <ResponsiveCommandMultiSelectList {...listProps} />
        </div>
      }
      title={title}
      className={cn("p-0 max-w-none w-auto overflow-x-visible", highZIndex && "z-[9999]")}
      align="start"
      popoverSide="bottom"
      offset={12}
      withinPortal={!isInDialog}
      asChild={true}
    >
      {trigger}
    </ResponsivePopover>
  );
}
